var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _vm.tdbVisible
        ? _c(
            "div",
            [
              _c("TempDesignBanner", {
                attrs: { tdbHeight: _vm.tdbHeight },
                on: {
                  updateTdbHeight: function($event) {
                    _vm.tdbHeight = $event
                  },
                  tdbCloseFunc: _vm.tdbCloseFunc
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("AppHeader", {
        attrs: { tdbHeight: _vm.tdbHeight, headerHeight: _vm.headerHeight },
        on: {
          updateHeaderHeight: function($event) {
            _vm.headerHeight = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "app-body",
          style: { "margin-top": _vm.tdbHeight + _vm.headerHeight + "px" }
        },
        [
          _c("Sidebar", { attrs: { navItems: _vm.nav } }),
          _vm._v(" "),
          _c(
            "main",
            { staticClass: "main" },
            [
              _c("breadcrumb", { attrs: { list: _vm.list } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container-fluid" },
                [_c("router-view")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("AppFooter")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6c6ec7a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6c6ec7a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 1454
// module chunks = 0